import agent from "../api/agent";

export type EmailLogStore = {
  logs: any[];
  loading: boolean;

  fetchLogs: () => Promise<void>;
  downloadLogPdf: (id: string) => Promise<void>;

  sendEmail: (payload: { memberIds: string[]; templateId?: string; body?: string; variables?: Record<string, string> }) => Promise<void>;
  generateBatchLettersPdf: (memberIds: string[], templateId?: string, body?: string, variables?: Record<string, string>) => Promise<void>;

  getBatchInfos: () => Promise<{ batchId: string; subject: string; createdAt: string }[]>;
  downloadBatchPdf: (batchId: string) => Promise<void>;
  deleteBatch: (batchId: string) => Promise<void>;

  getLettersForMember: (memberId: string) => Promise<any[]>;
  downloadLetterPdf: (letterId: string) => Promise<void>;
};

export const createEmailLogStore = (set: any, _get: any): EmailLogStore => ({
  logs: [],
  loading: false,

  fetchLogs: async () => {
    set((s: any) => ({ emailLogStore: { ...s.emailLogStore, loading: true } }));
    try {
      const res = await agent.Emails.getLogs();
      set((s: any) => ({ emailLogStore: { ...s.emailLogStore, logs: res || [], loading: false } }));
    } catch (e) {
      console.error(e);
      set((s: any) => ({ emailLogStore: { ...s.emailLogStore, loading: false } }));
    }
  },

  downloadLogPdf: async (id: string) => {
    const blob = await agent.Emails.downloadLogPdf(id);
    const url = URL.createObjectURL(new Blob([blob]));
    const a = document.createElement("a");
    a.href = url;
    a.download = `email-log-${id}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  },

  sendEmail: async (payload) => {
    await agent.Emails.send(payload);
  },

  generateBatchLettersPdf: async (memberIds, templateId, body, variables) => {
    await agent.Emails.generateBatchLettersPdf({ memberIds, templateId, body, variables });
  },

  getBatchInfos: async () => {
    const res = await agent.Emails.getBatchInfos();
    return res || [];
  },

  downloadBatchPdf: async (batchId: string) => {
    const blob = await agent.Emails.downloadBatchPdf(batchId);
    const url = URL.createObjectURL(new Blob([blob]));
    const a = document.createElement("a");
    a.href = url;
    a.download = `batch-${batchId}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  },

  deleteBatch: async (batchId: string) => {
    await agent.Emails.deleteBatch(batchId);
  },

  getLettersForMember: async (memberId: string) => {
    const res = await agent.Emails.getLettersForMember(memberId);
    return res || [];
  },

  downloadLetterPdf: async (letterId: string) => {
    const blob = await agent.Emails.downloadLetterPdf(letterId);
    const url = URL.createObjectURL(new Blob([blob]));
    const a = document.createElement("a");
    a.href = url;
    a.download = `letter-${letterId}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  },
});
